import { createContext, ReactNode, use, useMemo, useState } from "react";

export interface HeatsFilterContextType {
  ignoredMaterials: Set<string>;
  setIgnoredMaterials: (ignoredMaterials: Set<string>) => void;
  finalSampleOnly: boolean;
  setFinalSampleOnly: (finalSampleOnly: boolean) => void;
}

const HeatsFilterContext = createContext<HeatsFilterContextType | undefined>(
  undefined
);

interface HeatsFilterProviderProps {
  children: ReactNode;
}

export const HeatsFilterProvider = ({ children }: HeatsFilterProviderProps) => {
  const [ignoredMaterials, setIgnoredMaterials] = useState(
    () => new Set<string>()
  );
  const [finalSampleOnly, setFinalSampleOnly] = useState(true);

  const value: HeatsFilterContextType = useMemo(
    () => ({
      ignoredMaterials,
      setIgnoredMaterials,
      finalSampleOnly,
      setFinalSampleOnly,
    }),
    [ignoredMaterials, finalSampleOnly]
  );

  return <HeatsFilterContext value={value}>{children}</HeatsFilterContext>;
};

export const useHeatsFilter = (): HeatsFilterContextType => {
  const context = use(HeatsFilterContext);
  if (context === undefined) {
    throw new Error("useHeatsFilter must be used within a HeatsFilterProvider");
  }
  return context;
};
